// extracted by mini-css-extract-plugin
module.exports = {"end":"end-module--end--1lp34","text":"end-module--text--2YQ8v"};